module.exports = __webpack_public_path__ + "img/Medical Folder.a8e3951.png";